import $ from 'jquery';
import * as HTML_RENDITION from '../../utils/general/general';

// Inject internal css -- by using a <style> element in the <head> section
export const serviceInjectInternalCss = (data: any) => {
    $('head').append('<style type="text/css">' + data + '</style>');
};

// Inject external css - by using an external CSS file
export const serviceInjectCss = (url: string, isRenditionUrl: boolean) => {
    if (isRenditionUrl) url = HTML_RENDITION.documentsPath_version() + url;
    url = HTML_RENDITION.addParam(url, 'ts', String(HTML_RENDITION.timestamp()));
    if (HTML_RENDITION.isCPServer()) url = HTML_RENDITION.addCPServerParam(url);
    $('head').append(`<link rel="stylesheet" type="text/css" href="${url}" />`);
};

export const serviceInjectScript = (data: any, isRenditionUrl: boolean, isSync: boolean) => {
    if (isRenditionUrl) data = HTML_RENDITION.documentsPath_version() + data;
    if (HTML_RENDITION.isCPServer()) data = HTML_RENDITION.addCPServerParam(data);
    const s = document.createElement('script');
    s.type = 'text/javascript';
    if (isSync) {
        s.async = false;
    } else {
        s.async = true;
    }
    s.src = data;
    document.getElementsByTagName('head')[0].appendChild(s);
    return s;
};
